import React from 'react';
import { BadgeCheck, Download, Share2 } from 'lucide-react';
import { useLocalization } from '../context/LocalizationContext';

export const PwaInstallSection = ({
  canPromptInstall,
  isInstalled,
  isIosSafari,
  onInstall,
}) => {
  const { t } = useLocalization();

  return (
    <div className="app-surface app-surface-section">
      <div className="flex items-start gap-3">
        <div className="app-icon-chip mt-0.5 h-12 w-12 shrink-0 bg-primary-500 text-white shadow-sm">
          {isInstalled ? <BadgeCheck size={22} /> : isIosSafari ? <Share2 size={22} /> : <Download size={22} />}
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="app-panel-title">
            {isInstalled ? t('pwa.installedTitle') : t('pwa.sectionTitle')}
          </h2>
          <p className="app-panel-subtitle mt-1">
            {isInstalled
              ? t('pwa.installedSubtitle')
              : isIosSafari
                ? t('pwa.iosSectionSubtitle')
                : t('pwa.sectionSubtitle')}
          </p>

          {isInstalled ? (
            <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-green-50 px-4 py-2 text-sm font-semibold text-green-700 dark:bg-green-900/20 dark:text-green-300">
              <BadgeCheck size={16} />
              <span>{t('pwa.alreadyInstalled')}</span>
            </div>
          ) : isIosSafari ? (
            <div className="app-note mt-4">
              <p className="text-sm text-primary-800 dark:text-primary-200">{t('pwa.iosSteps')}</p>
            </div>
          ) : canPromptInstall ? (
            <button
              type="button"
              onClick={onInstall}
              className="app-primary-button mt-4 rounded-full px-5"
              data-testid="pwa-install-profile-button"
            >
              <Download size={16} />
              <span>{t('pwa.installNow')}</span>
            </button>
          ) : (
            <div className="app-note mt-4">
              <p className="text-sm text-primary-800 dark:text-primary-200">{t('pwa.sectionUnavailable')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PwaInstallSection;
